import { Helmet } from 'react-helmet-async';
import About from './components/About';
import ContactSection from './components/ContactSection';
import EducationSection from './components/EducationSection';
import ExperienceTimeline from './components/ExperienceTimeline';
import Footer from './components/Footer';
import GitHubSection from './components/GitHubSection';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import ProjectsGrid from './components/ProjectsGrid';
import SkillsSection from './components/SkillsSection';
import TechStack from './components/TechStack';
import { siteConfig } from './data/portfolio';

function App() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: siteConfig.name,
    jobTitle: siteConfig.title,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Bangalore',
      addressCountry: 'India',
    },
    description: siteConfig.metaDescription,
    email: siteConfig.email,
    sameAs: [siteConfig.linkedinUrl, siteConfig.githubUrl].filter(Boolean),
    knowsAbout: siteConfig.keywords,
    url: siteConfig.siteUrl,
  };

  return (
    <>
      <Helmet>
        <title>{siteConfig.metaTitle}</title>
        <meta name="description" content={siteConfig.metaDescription} />
        <meta name="keywords" content={siteConfig.keywords.join(', ')} />
        <meta name="author" content={siteConfig.name} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteConfig.metaTitle} />
        <meta property="og:description" content={siteConfig.metaDescription} />
        <meta property="og:url" content={siteConfig.siteUrl} />
        <meta property="og:image" content={`${siteConfig.siteUrl}/og-image.svg`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteConfig.metaTitle} />
        <meta name="twitter:description" content={siteConfig.metaDescription} />
        <meta name="twitter:image" content={`${siteConfig.siteUrl}/og-image.svg`} />
        <link rel="canonical" href={siteConfig.siteUrl} />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <div className="relative min-h-screen overflow-hidden bg-canvas text-white">
        <div className="pointer-events-none absolute inset-0 bg-grid-pattern bg-[size:44px_44px] opacity-20 [mask-image:radial-gradient(circle_at_center,black_30%,transparent_85%)]" />
        <div className="pointer-events-none absolute left-[-12rem] top-[-8rem] h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" />
        <div className="pointer-events-none absolute right-[-8rem] top-40 h-80 w-80 rounded-full bg-teal-400/15 blur-3xl" />

        <Navbar
          initials={siteConfig.initials}
          navItems={siteConfig.navItems}
          linkedinUrl={siteConfig.linkedinUrl}
        />

        <main className="relative z-10">
          <Hero siteConfig={siteConfig} />
          <About siteConfig={siteConfig} />
          <ExperienceTimeline experience={siteConfig.experience} />
          <ProjectsGrid projects={siteConfig.projects} />
          <SkillsSection skills={siteConfig.skills} />
          <TechStack techStack={siteConfig.techStack} />
          <GitHubSection
            githubUrl={siteConfig.githubUrl}
            githubDisplayText={siteConfig.githubDisplayText}
          />
          <EducationSection education={siteConfig.education} />
          <ContactSection siteConfig={siteConfig} />
        </main>

        <Footer siteConfig={siteConfig} />
      </div>
    </>
  );
}

export default App;
